export type ScheduleKind = 'personal' | 'daycare' | 'group';

export type ScheduleTab = {
	id: 'timeslot' | 'timetable' | 'session' | 'stats' | 'history';
	name: string;
	link: string;
};

const SECTIONS: Record<
	ScheduleKind,
	{ title: string; tabs: ScheduleTab[] }
> = {
	personal: {
		title: 'Lịch học cá nhân',
		tabs: [
			{ id: 'timeslot', name: 'Lịch ngày', link: '/schedule/timeslot' },
			{
				id: 'timetable',
				name: 'Thời khoá biểu',
				link: '/schedule/timetable',
			},
			{
				id: 'session',
				name: 'Điều phối lịch học',
				link: '/session-management',
			},
			{ id: 'stats', name: 'Thống kê', link: '/schedule/stats' },
			{
				id: 'history',
				name: 'Lịch sử TKB',
				link: '/schedule/timetable-history',
			},
		],
	},
	daycare: {
		title: 'Lịch học bán trú',
		tabs: [
			{
				id: 'timeslot',
				name: 'Lịch ngày',
				link: '/schedule/timeslot/daycare',
			},
			{
				id: 'timetable',
				name: 'Thời khoá biểu',
				link: '/schedule/timetable?type=daycare',
			},
			{
				id: 'session',
				name: 'Điều phối lịch học',
				link: '/session-management/daycare',
			},
			{
				id: 'stats',
				name: 'Thống kê',
				link: '/schedule/stats?type=daycare',
			},
		],
	},
	group: {
		title: 'Lịch học nhóm',
		tabs: [
			{
				id: 'timeslot',
				name: 'Lịch ngày',
				link: '/schedule/timeslot/group',
			},
			{
				id: 'timetable',
				name: 'Thời khoá biểu',
				link: '/schedule/timetable/group-classes',
			},
			{
				id: 'session',
				name: 'Điều phối lịch học',
				link: '/session-management/group-class',
			},
			{
				id: 'stats',
				name: 'Thống kê chuyên cần',
				link: '/schedule/stats?type=group',
			},
		],
	},
};

function queryValue(value) {
	if (Array.isArray(value)) return value[0] || '';
	return value ? String(value) : '';
}

export function scheduleKindFromRoute(route): ScheduleKind {
	const path = route?.path || '';
	const type = queryValue(route?.query?.type);
	if (type === 'daycare' || /daycare|day-care/.test(path)) return 'daycare';
	if (type === 'group' || /\/group/.test(path)) return 'group';
	return 'personal';
}

export function scheduleSectionTitle(route) {
	return SECTIONS[scheduleKindFromRoute(route)].title;
}

export function scheduleSectionTabs(route): ScheduleTab[] {
	return SECTIONS[scheduleKindFromRoute(route)].tabs;
}

export function isScheduleTabActive(tab: ScheduleTab, route) {
	const path = route?.path || '';
	if (tab.id === 'timeslot') return path.startsWith('/schedule/timeslot');
	if (tab.id === 'timetable') {
		return (
			path === '/schedule/timetable' ||
			path.startsWith('/schedule/timetable/')
		);
	}
	if (tab.id === 'history') return path === '/schedule/timetable-history';
	if (tab.id === 'session') return path.startsWith('/session-management');
	if (tab.id === 'stats') {
		return path === '/schedule/stats' || path.startsWith('/schedule/stats/');
	}
	return false;
}

export function isScheduleMenuActive(kind: ScheduleKind, route) {
	if (scheduleKindFromRoute(route) !== kind) return false;
	return SECTIONS[kind].tabs.some((tab) => isScheduleTabActive(tab, route));
}
